const Sliders = {
  instances: {},
  config(type = 'default', options = {}) {
    const baseParams = {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
    }
    const params = {
      default: {
        ...baseParams,
        slidesPerView: 1,
        breakpoints: {
          180: {
            slidesPerView: 1.2,
          },
          280: {
            slidesPerView: 1.8,
          },
          430: {
            slidesPerView: 2.4,
          },
          600: {
            slidesPerView: 3,
          },
          800: {
            slidesPerView: 3.5,
          },
          1000: {
            slidesPerView: 4.5,
          },
          1200: {
            slidesPerView: 5,
          },
        },
      },
    }

    if (!(type in params)) {
      type = 'default'
    }

    return {
      ...params[type],
      ...options,
    }
  },

  init(element, type = 'default', options = {}) {
    if (!element) return
    const finalConfig = Sliders.config(type, options)
    console.log(finalConfig)
    const slider = new Swiper(element, finalConfig)
    const id = element.dataset.sliderId || Date.now()
    this.instances[id] = slider
    return slider
  },

  getInstance(id) {
    return this.instances[id]
  },

  updateConfig(id, options) {
    const slider = this.getInstance(id)
    if (slider) {
      Object.assign(slider.params, options)
      slider.update()
    }
  },

  initAll() {
    const productsSliders = DOM.select('.m-carousel', true)

    if (productsSliders && productsSliders.length > 0) {
      productsSliders.forEach((slider) => {
        this.init(slider, slider.dataset.items)
      })
    }
  },
}

export default Sliders
